export default __webpack_public_path__ + "static/media/spesial.619a6b58.svg";